// extracted by mini-css-extract-plugin
export var bar = "boxSection-module--bar--65dfd";
export var beige = "boxSection-module--beige--e8323";
export var white = "boxSection-module--white--4dcf8";
export var wrapper = "boxSection-module--wrapper--ca8ca";